module.exports = "//static.hsappstatic.net/academy-common-lib/static-1.9845/fonts/HubSpotSerif-Medium.woff2"